<template>
  <ul>
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'v-thead'
}
</script>



// WEBPACK FOOTER //
// VThead.vue?1e7940d0